// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 2076) return "static/chunks/common-8ecd69b917e61f2d.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"945":"dashboard","3106":"dashboard-libs"}[chunkId] || chunkId) + "." + {"945":"a8e4670b8bffdd06","2419":"17c263c0e9571ad7","2921":"c3de329486b7dbcb","3106":"a7b6f68bb088fb84","4990":"e127cf53e76e4635","6611":"e9c156ff8275fe4b","9979":"b9b53a8c0bda06ab"}[chunkId] + ".js";
};